import React from 'react';
import {
  CodeMirror as CKCodeMirror,
  IsInvertedProvider,
  Panel,
  Header,
  PropTypes,
  createComponent,
  enums,
} from 'console-kit';
import { promotionalContentNote } from '../../../../../../common/components/EmailNotifications';

const options = {
  mode:              'htmlmixed-ruby',
  theme:             'code-mirror-dark',
  matchBrackets:     true,
  autoCloseBrackets: true,
  matchTags:         { bothTags: true },
  autoCloseTags:     true,
  lineNumbers:       true,
};

const DesignerContentTab = createComponent({
  displayName: 'designerContentTab',
  propTypes:   {
    fieldChanged:             PropTypes.func.isRequired,
    checkEmailTemplateTokens: PropTypes.func.isRequired,
    body:                     PropTypes.string,
    id:                       PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  },
  defaultProps: {
    body: '',
  },
  lifecycles: {
    shouldComponentUpdate(nextProps) {
      return !_.isEqual(this.props, nextProps);
    },

    componentDidMount() {
      // We are creating a new CodeMirror mode so that we can highlight "${}". We use the htmlmixed default from CodeMirror,
      // which requires that we provided it with css, xml, javascript and we combine the syntax, using multiplex, with Ruby
      // which will provide Ruby syntax highlight ONLY for code between "${" and "}". This will mimic the GSP code
      // syntax highlight.
      CodeMirror.defineMode('htmlmixed-ruby', function (config) {
        return CodeMirror.multiplexingMode(
          CodeMirror.getMode(config, 'text/html'),
          {
            open:       '${',
            close:      '}',
            mode:       CodeMirror.getMode(config, 'ruby'),
            delimStyle: 'delimit',
          }
          // .. more multiplexed styles can follow here
        );
      });
    },
  },
  handlers: {
    _bodyFieldChanged:
      ({ fieldChanged }) =>
        (e, { value }) => {
          fieldChanged({
            instanceConfig: {
              body: value,
            },
          });
        },

    _bodyFieldOnFocusToggle:
      ({ checkEmailTemplateTokens }) =>
        (isFocused) => {
          if (isFocused === false) {
            checkEmailTemplateTokens();
          }
        },
  },
  render(props) {
    return (
      <IsInvertedProvider isInverted={true}>
        <div className="campaign-customise campaign-customise-codemirror-wrapper">
          <Panel
            hasBorder={false}
            padding={{
              vertical:   enums.sizes.X4,
              horizontal: enums.sizes.X4,
            }}
          >
            <Header
              text="Email Body"
              byline='Enter the HTML/CSS/text that forms the body of your email. To display dynamic values, you can use the tokens listed in the Help panel. Please note that "$" is a reserved character for use of tokens, if you need to use the dollar sign symbol, use "\\$" instead.'
              style={{ marginBottom: 10 }}
            />
            <p>
              <b>{promotionalContentNote}</b>
            </p>
            <CKCodeMirror
              value={props.body}
              onChange={_.debounce(props._bodyFieldChanged, 500)}
              options={options}
              codeMirrorInstance={CodeMirror}
              onFocusChange={props._bodyFieldOnFocusToggle}
            />
          </Panel>
        </div>
      </IsInvertedProvider>
    );
  },
});

export default DesignerContentTab;
